import React from 'react';
import { styled } from '@mui/material/styles';
import { SvgIcon } from '@mui/material';
import { Link } from 'gatsby';
import StepsProgressBar from 'components/StepsProgressBar';
import { ReactComponent as DrSmileImpressLogo } from 'mui/assets/icons/DRSXIMPRESS.svg';
import { ReactComponent as DrSmileLogoIcon } from 'mui/assets/icons/drsmile-black-logo.svg';
import { SharedSimpleHeaderStyles } from '../sharedStyles';
import { isDRSmileInactive } from '../../../../../../data/isDRSmileInactive';

export default function SimpleHeader({ data, isHomepageLinkDisabled }) {
  const { hasProgressBar } = data;
  const brandLogo = isDRSmileInactive ? DrSmileLogoIcon : DrSmileImpressLogo;
  return (
    <StyledHeader $isDRSmileInactive={isDRSmileInactive} style={{ backgroundColor: 'white' }}>
      {isHomepageLinkDisabled ? (
        <SvgIcon component={brandLogo} inheritViewBox={true}></SvgIcon>
      ) : (
        <Link to="/" aria-label="DrSmile Home">
          <SvgIcon component={brandLogo} inheritViewBox={true}></SvgIcon>
        </Link>
      )}
      {hasProgressBar ? <StepsProgressBar /> : null}
    </StyledHeader>
  );
}

const StyledHeader = styled('header')(
  ({ theme, $isDRSmileInactive }) => `
  ${SharedSimpleHeaderStyles({ theme, $isDRSmileInactive })};
`,
);
